import React, { useState } from "react";

import dayjs from "dayjs";

import { KeyboardDatePicker } from "@material-ui/pickers";

export const CommonDatePicker = ({
  id,
  label,
  values,
  errors,
  touched,
  setFieldValue,
  disabled,
  openTo,
  views,
  className,
  format = "yyyy/MM/dd",
  ...props
}: any) => {
  //State
  const [selectedDate, handleDateChange] = useState(
    values[id] ? dayjs(values[id]).format("YYYY-MM-DD") : null
  );

  //Options
  const isValidationFailed = errors && touched && errors[id] && touched[id];

  return (
    <KeyboardDatePicker
      {...props}
      openTo={openTo}
      views={views}
      autoOk
      disabled={disabled}
      className={className}
      clearable
      value={selectedDate}
      inputVariant="outlined"
      error={isValidationFailed}
      helperText={isValidationFailed ? errors[id] : ""}
      label={label}
      placeholder={format}
      onChange={(date: any) => {
        handleDateChange(date);
        setFieldValue(id, date);
      }}
      format={format}
    />
  );
};
